/* eslint-disable
    array-callback-return,
    func-names,
    guard-for-in,
    max-len,
    no-cond-assign,
    no-param-reassign,
    no-restricted-syntax,
    no-shadow,
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const deps = ['$rootScope'];
const factory = function ($rootScope) {
  let Store;
  const storeCache = {};

  return (Store = (function () {
    Store = class Store {
      static initClass() {
        // Stores can be not cached in the storeCache if they don't have storeId
        // this flag will be set if it's cached or not
        // override and set to false to prevent caching
        this.prototype.$$cached = true;

        this.prototype.$idName = '$id';

        this.prototype.$idSerializers = [];

        this.prototype.$$attrUnbindFns = {};

        // prefix for the events registered in $rootScope
        this.prototype.$$setEventPrefix = 'STORE_SET_';

        this.prototype.$$destroyEventPrefix = 'STORE_DESTROY_';
      }
      /*
       * Store, a class for storing arbitrary information that can be
       * accessed globally across your app, with helper methods to code.
       * in a functional way.
       *
       * @param  {object,number,string} data the initial data or
       *                                id or ID of the object
       * @param  {objects} $options see Store.$options
       * @return {Store}
       */
      constructor(id, data) {
        // allow user to set data with the first argument
        if (id != null && typeof id === 'object') {
          data = id;
          id = data[this.$idName];
        }

        // used for notifying listener states that new things happened
        this.$lastUpdated = 0;

        // registry of states this store is listening to
        this.$$storesListenedTo = {};

        // set data if data was given in constructor
        if (data) {
          this.$set(data);
        }

        // set the id according to $idName if it's given
        this.$setId(id);

        // cache if @$$cached is not false
        // if it's already cached, @$cache() will apply new changes and
        // return the cached store which we return.
        if (this.$$cached || this.$checkCache()) {
          let cachedStore;
          if ((cachedStore = this.$cache(data)) !== this) {
            return cachedStore;
          }
        }

        // run init if this is a new store
        this.$init(data);

        return this;
      }

      $serializeId(id) {
        return this.$idSerializers
          .map(attr => {
            const val = this[attr];
            if (val) {
              return `${attr}=${val}`;
            }
          })
          .filter(val => val)
          .join('&');
      }

      $setId(id) {
        return (this[this.$idName] = id || this.$serializeId(id) || this[this.$idName]);
      }

      $storeId() {
        return this[this.$idName];
      }

      // optional init function to be extended
      $init() {
        return this;
      }

      // gets the name of the current class
      $className() {
        return this.constructor.name;
      }

      // used for caching and fetching purposes
      $cacheId() {
        return `${this.$className()}-${this.$storeId()}`;
      }

      // generates a new object that only contains the data properties of the data
      // passed in as an argument
      $$filterData(data) {
        const obj = {};
        for (const key in data) {
          const val = data[key];
          if (key[0] !== '$' && key !== 'constructor' && typeof val !== 'function') {
            obj[key] = angular.copy(val);
          }
        }
        return obj;
      }

      // generates a new object that only contains the data properties of the store
      // listed in $defaults
      $data() {
        return this.$$filterData(this);
      }

      // Returns JSON sting of the current object containing only the data of the model
      $toJson() {
        return angular.toJson(this.$data());
      }

      /*
       * $set, changes the data in the model without invalidating
       * the object reference and updates any associated viewModels
       *
       * @param  {object}  data to be set in the model
       * @param  {object}  options see Store.$options
       * @return {Store}
       */
      $set(data, opts = {}) {
        if (opts.updateTime == null) {
          opts.updateTime = Date.now();
        }

        if (this.$lastUpdated > opts.updateTime) {
          return;
        }

        const oldData = this.$data();

        angular.extend(this, this.$$filterData(data));

        // notify stores $listening to this store that there is a change
        if (!angular.equals(oldData, this.$data())) {
          this.$lastUpdated = opts.updateTime;
          $rootScope.$emit(this.$$setEventName(), this.$data(), oldData, opts.updateTime);
        }
        return this;
      }

      // set private attributes on the store safely
      $setPrivateAttrs(data) {
        const obj = {};

        for (const key in data) {
          const val = data[key];
          if (key[0] === '$' && key !== 'constructor' && typeof val !== 'function') {
            obj[key] = angular.copy(val);
          }
        }

        angular.extend(this, obj);

        return obj;
      }

      $bindAttr(attr, watchFn, transformFn) {
        // unbind existing bindings
        this.$unBindAttr(attr);

        return (this.$$attrUnbindFns[attr] = $rootScope.$watch(
          () => watchFn.apply(this),
          val => (this[attr] = transformFn != null ? transformFn.call(this, val) : val),
        ));
      }

      $unBindAttr(attr) {
        return typeof this.$$attrUnbindFns[attr] === 'function'
          ? this.$$attrUnbindFns[attr]()
          : undefined;
      }

      // default function used to transform data when listening to other stores
      $listenTransformFn(newData, oldData, lastUpdated) {
        return newData;
      }

      // id of event emitted on set
      $$setEventName(store = this) {
        return `${this.$$setEventPrefix}${store.$cacheId()}`;
      }

      // id of event emitted on destroy
      $$destroyEventName(store = this) {
        return `${this.$$destroyEventPrefix}${store.$cacheId()}`;
      }

      /*
       * $listen, registers a store to watch. Registered stores
       * will update this store according to their $$lastUpdated timestamp.
       *
       * @params  {Store}  store  store to watch and register
       * @returns {Store}  this object
       */
      $listen(store, transformFn = this.$listenTransformFn) {
        // prevent double-listening
        if (
          this.$$storesListenedTo[
            typeof store.$cacheId === 'function' ? store.$cacheId() : undefined
          ]
        ) {
          return this;
        }

        const setStore = (...args) =>
          this.$set(transformFn.apply(this, args), { updateTime: args[2] });

        // grab the store's data initially if it's newer
        setStore(store.$data(), {}, store.$lastUpdated);

        // watch for new changes from the store
        const unsubFn = $rootScope.$on(this.$$setEventName(store), function (e, ...args) {
          return setStore.apply(this, args);
        });

        // log who we're listening to so we can remove listeners
        this.$$storesListenedTo[store.$cacheId()] = {
          obj: store,
          unsubFn,
        };

        return this;
      }

      /*
       * $onSet, registers callbacks to be triggered on $set
       */
      $onSet(cb) {
        // send the initial value if it exists
        if (this.$lastUpdated > 0) {
          cb(this.$data(), null, this.$lastUpdated);
        }

        return $rootScope.$on(this.$$setEventName(), cb);
      }

      /*
       * $onDestroy, registers callbacks to be triggered on $destroy
       */
      $onDestroy(cb) {
        // TODO : pass in store id and add it to @$$storesDestroyWatch[store.$cacheId?()] (or something like that)
        // Do not add to rootscope when storeid is a duplicate.
        return $rootScope.$on(this.$$destroyEventName(), cb);
      }

      /*
       * $clearListens, clears all listeners
       */
      $clearListens() {
        return Object.keys(this.$$storesListenedTo).forEach(key => {
          this.$$storesListenedTo[key].unsubFn();
        });
      }

      /*
       * $unListen: ->
       */
      $unListen(store) {
        let unsubFn;
        const cacheId = store.$cacheId();
        if (
          (unsubFn =
            this.$$storesListenedTo[cacheId] != null
              ? this.$$storesListenedTo[cacheId].unsubFn
              : undefined)
        ) {
          return unsubFn();
        }
      }

      /*
       * $destroy, destroy things
       */
      $destroy() {
        this.$clearListens();
        $rootScope.$emit(this.$$destroyEventName(), this);
        delete storeCache[this.$cacheId()];
      }

      /*
       * $extend, allows users to extend the class directly
       */
      static $extend(data) {
        const copyStore = angular.copy(this);
        return angular.extend(copyStore, data);
      }

      /*
       * $checkCache, check if cacheID is in cache
       */
      static $checkCache(cacheId) {
        return storeCache[cacheId];
      }

      $checkCache(cacheId = this.$cacheId()) {
        return Store.$checkCache(cacheId);
      }

      static $listCache() {
        return Object.keys(storeCache);
      }

      /*
       * $cache(), force store to be cached
       * returns cached store if exists
       */
      $cache(data = this) {
        if (this.$storeId() == null) {
          this.$$cached = false;
          return this;
        }

        const existingStore = this.$checkCache();
        if (!existingStore) {
          this.$$cached = true;
          storeCache[this.$cacheId()] = this;
        } else if (existingStore) {
          existingStore.$set(data, { updateTime: this.$lastUpdated });
        }

        return this.$checkCache(); // always return cached store
      }

      /**
       * Unsubscribes from a previously subscribed event.
       * @param {string} action The event name to unsubscribe from.
       */
      $unsubscribe(action) {
        /*
         * $$subscriptions is an object that keeps track of all active subscriptions
         * for this store instance. The key is the event name and the value is a
         * function that unsubscribes from the event when called.
         */
        if (this.$$subscriptions && typeof this.$$subscriptions[action] === 'function') {
          this.$$subscriptions[action]();
          delete this.$$subscriptions[action];
        }
      }

      /**
       * Subscribes to a custom event on the window object and stores the subscription
       * in the $$subscriptions object as a key-value pair, where the key is the event
       * name and the value is a function that unsubscribes from the event when called.
       * @param {string} action The event name to subscribe to.
       * @param {Function} fn The callback function to be invoked when the event is triggered.
       * @returns {Function} A function that can be called to unsubscribe from the event.
       */
      $subscribe(action, fn) {
        // Avoid subscribing multiple times to the same event
        this.$unsubscribe(action);
        if (this.$$subscriptions == null) {
          this.$$subscriptions = {};
        }

        const handler = event => {
          const detail = event.detail;
          const args = detail == null ? [] : Array.isArray(detail) ? detail : [detail];
          $rootScope.$evalAsync(() => {
            fn.apply(this, args);
          });
        };

        window.addEventListener(action, handler);

        return (this.$$subscriptions[action] = () => {
          window.removeEventListener(action, handler);
        });
      }
    };
    Store.initClass();
    return Store;
  })());
};

factory.$inject = deps;
module.exports = factory;
